// Framework-agnostic Razorpay Checkout loader/opener. No React imports here on purpose —
// this is shared between the Billing page and the Marketing page's pricing section.

const SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";
let scriptPromise = null;

export function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve(window.Razorpay);
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existing) {
      if (window.Razorpay) return resolve(window.Razorpay);
      existing.addEventListener("load", () => resolve(window.Razorpay));
      existing.addEventListener("error", () => reject(new Error("Failed to load Razorpay checkout script")));
      return;
    }
    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve(window.Razorpay);
    script.onerror = () => reject(new Error("Failed to load Razorpay checkout script"));
    document.head.appendChild(script);
  });

  return scriptPromise;
}

export async function openRazorpayCheckout({
  key,
  subscription_id,
  name,
  description,
  prefill,
  themeColor,
  onSuccess,
  onDismiss,
}) {
  const Razorpay = await loadRazorpayScript();
  // For subscription checkout, pass ONLY subscription_id — Checkout derives the charge
  // (₹5 mandate authorisation for future-dated subscriptions, or the first cycle amount).
  // Passing a conflicting `amount`/`currency` here breaks UPI QR / intent generation.
  const rzp = new Razorpay({
    key,
    subscription_id,
    name,
    description,
    prefill,
    theme: { color: themeColor || "#2563EB" },
    handler: (resp) => onSuccess?.(resp),
    modal: { ondismiss: () => onDismiss?.() },
  });
  rzp.open();
  return rzp;
}
